/* ============================================
   WILD RIDGE HUNTING - THEME JS
   ============================================ */

document.addEventListener('DOMContentLoaded', () => {

  // ---- HERO CAROUSEL ----
  class HeroCarousel {
    constructor(el) {
      this.el = el;
      this.track = el.querySelector('.carousel-track');
      this.slides = [...el.querySelectorAll('.carousel-slide')];
      this.dots  = [...el.querySelectorAll('.carousel-dot')];
      this.prev  = el.querySelector('.carousel-prev');
      this.next  = el.querySelector('.carousel-next');
      this.current = 0;
      this.total   = this.slides.length;
      this.timer   = null;

      if (this.total < 2) return;

      this.prev?.addEventListener('click', () => this.go(this.current - 1));
      this.next?.addEventListener('click', () => this.go(this.current + 1));
      this.dots.forEach((d, i) => d.addEventListener('click', () => this.go(i)));

      // Touch / swipe
      let startX = 0;
      this.track.addEventListener('touchstart', e => { startX = e.touches[0].clientX; }, { passive: true });
      this.track.addEventListener('touchend', e => {
        const diff = startX - e.changedTouches[0].clientX;
        if (Math.abs(diff) > 50) this.go(this.current + (diff > 0 ? 1 : -1));
      });

      this.go(0);
      this.startAuto();
    }

    go(idx) {
      this.slides[this.current]?.classList.remove('active');
      this.dots[this.current]?.classList.remove('active');
      this.current = ((idx % this.total) + this.total) % this.total;
      this.track.style.transform = `translateX(-${this.current * 100}%)`;
      this.slides[this.current]?.classList.add('active');
      this.dots[this.current]?.classList.add('active');
      this.resetAuto();
    }

    startAuto() { this.timer = setInterval(() => this.go(this.current + 1), 5500); }
    resetAuto()  { clearInterval(this.timer); this.startAuto(); }
  }

  const carouselEl = document.querySelector('.hero-carousel');
  if (carouselEl) new HeroCarousel(carouselEl);

  // ---- CART DRAWER ----
  const cartDrawer  = document.getElementById('cart-drawer');
  const cartOverlay = document.getElementById('cart-overlay');
  const cartCount   = document.querySelectorAll('.cart-count');

  function openCart() {
    cartDrawer?.classList.add('open');
    cartOverlay?.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    cartDrawer?.classList.remove('open');
    cartOverlay?.classList.remove('open');
    document.body.style.overflow = '';
  }

  document.querySelectorAll('[data-cart-open]').forEach(b => b.addEventListener('click', openCart));
  document.querySelector('[data-cart-close]')?.addEventListener('click', closeCart);
  cartOverlay?.addEventListener('click', closeCart);

  // Add to cart
  document.querySelectorAll('[data-add-to-cart]').forEach(btn => {
    btn.addEventListener('click', async (e) => {
      const form = btn.closest('form[action="/cart/add"]') || document.querySelector('#product-form');
      if (!form) return;
      btn.disabled = true;
      btn.textContent = 'Agregando...';
      try {
        const formData = new FormData(form);
        const res = await fetch('/cart/add.js', { method: 'POST', body: formData });
        if (res.ok) {
          await refreshCart();
          openCart();
        }
      } catch(err) { console.error(err); }
      finally {
        btn.disabled = false;
        btn.innerHTML = '<span>🛒</span> Agregar al Carrito';
      }
    });
  });

  async function refreshCart() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      cartCount.forEach(c => { c.textContent = cart.item_count; });
      renderCartItems(cart);
    } catch(e) {}
  }

  function renderCartItems(cart) {
    const container = document.getElementById('cart-items');
    const total = document.getElementById('cart-total');
    if (!container) return;
    if (cart.items.length === 0) {
      container.innerHTML = '<p style="text-align:center;color:var(--color-text-muted);padding:40px 0;">Tu carrito está vacío.</p>';
    } else {
      container.innerHTML = cart.items.map(item => `
        <div class="cart-item">
          <div class="cart-item-image">
            ${item.image ? `<img src="${item.image}" alt="${item.product_title}">` : '🎯'}
          </div>
          <div class="cart-item-info">
            <div class="cart-item-name">${item.product_title}</div>
            ${item.variant_title !== 'Default Title' ? `<div class="cart-item-variant">${item.variant_title}</div>` : ''}
            <div class="cart-item-price">${formatMoney(item.line_price)}</div>
          </div>
        </div>
      `).join('');
    }
    if (total) total.textContent = formatMoney(cart.total_price);
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  // ---- MOBILE NAV ----
  const mobileNav    = document.getElementById('mobile-nav');
  const mobileToggle = document.querySelector('.mobile-menu-toggle');
  const mobileOverlay = mobileNav?.querySelector('.mobile-nav-overlay');
  const mobileClose  = mobileNav?.querySelector('[data-mobile-close]');

  mobileToggle?.addEventListener('click', () => { mobileNav?.classList.add('open'); });
  mobileOverlay?.addEventListener('click', () => { mobileNav?.classList.remove('open'); });
  mobileClose?.addEventListener('click', () => { mobileNav?.classList.remove('open'); });

  // ---- QUANTITY BUTTONS ----
  document.querySelectorAll('.qty-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const input = btn.parentElement.querySelector('.qty-input');
      if (!input) return;
      let val = parseInt(input.value) || 1;
      val = btn.dataset.action === 'plus' ? val + 1 : Math.max(1, val - 1);
      input.value = val;
    });
  });

  // ---- PRODUCT GALLERY THUMBNAILS ----
  document.querySelectorAll('.thumbnail').forEach(thumb => {
    thumb.addEventListener('click', () => {
      const src = thumb.dataset.src;
      const main = document.getElementById('main-product-image');
      if (main && src) { main.src = src; }
      document.querySelectorAll('.thumbnail').forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
    });
  });

  // ---- VARIANT BUTTONS ----
  document.querySelectorAll('.variant-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const group = btn.closest('.variant-options');
      group?.querySelectorAll('.variant-btn').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      const input = document.getElementById('variant-id');
      if (input && btn.dataset.variantId) input.value = btn.dataset.variantId;
    });
  });

  // ---- SCROLL REVEAL ----
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.style.opacity = '1';
        entry.target.style.transform = 'translateY(0)';
      }
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

  document.querySelectorAll('.product-card, .category-card, .testimonial-card').forEach(el => {
    el.style.opacity = '0';
    el.style.transform = 'translateY(24px)';
    el.style.transition = 'opacity 0.5s ease, transform 0.5s ease';
    observer.observe(el);
  });

  // ---- FILTER TOGGLES (Collection page) ----
  document.querySelectorAll('.filter-option').forEach(opt => {
    opt.addEventListener('click', () => { opt.classList.toggle('active'); });
  });

  // Load cart on page load
  refreshCart();
});
